import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage } from "../../../utlis/common";
import { MESSAGES } from "../../../utlis/messages";

const GET_ORDER_LIST = "orders";
const GET_ORDER_DETAIL_LIST = `orders/details`;



export const FetchOrderList = createAsyncThunk(
  "FetchInvoiceList",
  async ({ page, limit, search = "" }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${GET_ORDER_LIST}?page=${page}&limit=${limit}&search=${search}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

// details
export const FetchOrderDetailList = createAsyncThunk(
  "FetchOrderDetailList",
  async ({ order_number, page = 1, limit = 10 }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).get(
        `${GET_ORDER_DETAIL_LIST}?order_number=${order_number}&page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG);
      return rejectWithValue(error.response?.data);
    }
  }
);
